// extracted by mini-css-extract-plugin
module.exports = {"close":"_f0079adf","closeButton":"_17bd95c9"};